import { z } from 'zod';
const baseVolunteerSchema = z.object({
    positionId: z.string().uuid(),
    accountId: z.string().uuid(),
});
const volunteerSchema = baseVolunteerSchema.extend({
    participationId: z.string().uuid().optional(),
});
const existingVolunteerSchema = baseVolunteerSchema.extend({
    participationId: z.string().uuid(),
});
const addVolunteersParamsSchema = z.object({
    shiftId: z.string().uuid(),
    volunteers: volunteerSchema.array(),
});
const addVolunteersResponseSchema = z.object({
    added: z.string().uuid().array(),
    approved: z.string().uuid().array(),
});
export const addVolunteersFunctionDef = {
    name: 'addVolunteers',
    requestSchema: addVolunteersParamsSchema,
    responseSchema: addVolunteersResponseSchema,
};
